export const TEST_ID = 'onboardingFormContainer';

export const ENTER_KEY = 'Enter';
